import template from '../templates/functionParameters.html';

export default Marionette.View.extend({
    template: Handlebars.compile(template)
});
